export const itemsGeneratingChanges = {
  41346129: {
    contrato: true,
    especialidad: true,
    claseExamen1: true,
    estadio: true,
    canalAtencion1: true,
    meses1: true,
    mesesRenovacion: true,
    firstDuracion: true,
    duracionSeg: true,
    subPrograma: true,
    checks: true,
    filtroAsegurador: false,
    filtroPrograma: false,
    filtroEstadio: false,
    filtroSede: false,
    filtroEspecialidad: false,
    dateCreate: false,
    canalAtencion2: false,
    claseExamen2: false,
    anos: false,
    meses2: false,
    moverMesEspecialidad: false,
    moverAnoDe: false,
    moverMesDe: false,
    moverAñoA: false,
    moverMesA: false,
  },
  41561613: {
    contrato: false,
    especialidad: false,
    claseExamen1: false,
    estadio: false,
    canalAtencion1: false,
    meses1: false,
    mesesRenovacion: false,
    firstDuracion: false,
    duracionSeg: false,
    subPrograma: false,
    checks: false,
    filtroAsegurador: true,
    filtroPrograma: true,
    filtroEstadio: true,
    filtroSede: true,
    filtroEspecialidad: true,
    dateCreate: true,
    canalAtencion2: true,
    claseExamen2: true,
    anos: true,
    meses2: true,
    moverMesEspecialidad: false,
    moverAnoDe: false,
    moverMesDe: false,
    moverAñoA: false,
    moverMesA: false,
  },
  41346130: {
    ResultadoContacto: true,
    PlanRutaAtención: false,
    Servicio: false,
    EtiquetaAdministrativa: true,
    MotivoInasistencia: false,
    ObservacionSeguimiento: true,
    NotaCambioEtiquetaAdministrativa: true,
  },
  41381695: {
    contrato: false,
    especialidad: false,
    claseExamen1: false,
    estadio: false,
    canalAtencion1: false,
    meses1: false,
    mesesRenovacion: false,
    firstDuracion: false,
    duracionSeg: false,
    subPrograma: false,
    checks: false,
    filtroAsegurador: true,
    filtroPrograma: true,
    filtroEstadio: true,
    filtroSede: true,
    filtroEspecialidad: true,
    dateCreate: false,
    canalAtencion2: true,
    claseExamen2: true,
    anos: true,
    meses2: true,
    moverMesEspecialidad: true,
    moverAnoDe: true,
    moverMesDe: true,
    moverAñoA: true,
    moverMesA: true,
  },
  41604590: {
    ResultadoContacto: true,
    PlanRutaAtención: true,
    Servicio: true,
    EtiquetaAdministrativa: false,
    MotivoInasistencia: false,
    ObservacionSeguimiento: true,
    NotaCambioEtiquetaAdministrativa: false,
  },
  null: {
    ResultadoContacto: false,
    PlanRutaAtención: false,
    Servicio: false,
    EtiquetaAdministrativa: false,
    MotivoInasistencia: false,
    ObservacionSeguimiento: false,
    NotaCambioEtiquetaAdministrativa: false,
  },
  undefined: {
    ResultadoContacto: false,
    PlanRutaAtención: false,
    Servicio: false,
    EtiquetaAdministrativa: false,
    MotivoInasistencia: false,
    ObservacionSeguimiento: false,
    NotaCambioEtiquetaAdministrativa: false,
  },
};
